import DataBaseDataHandlingRoutes from './DataBaseDataHandlingRoutes';

export default DataBaseDataHandlingRoutes;
